module.exports = __webpack_public_path__ + "static/media/chip_1000.b846275f.png";